<template>
  <!-- 运维报告 maintenanceReport-->
  <div class="FilesManage">
    <div class="left-tree">
      <el-tree :data="dataList" :expand-on-click-node="false" :current-node-key='defaultUnitId' node-key="id"
        :props="defaultProps" :highlight-current='true' default-expand-all :filter-node-method="filterNode" ref="tree"
        @node-click="nodeClick">
        <span class="custom-tree-node" slot-scope="{node, data}">
          <img src="../../../public/static/image/elTree/1.9.png" />
          <span style="padding-left: 5px;">{{node.label}}</span>
        </span>
      </el-tree>
    </div>
    <div class="right-table">
      <div class="content">
        <div class="Files-top">
          <div class="btns">
            <el-date-picker v-model="dataTime" type="year" placeholder="选择年" @change="getList">
            </el-date-picker>
          </div>
        </div>

        <div class="Files-table">
          <el-table :data="tableData" stripe style="width: 100%" :height="heights">
            <el-table-column label="序号" width="60" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" label="名称" min-width="200" align="center"> </el-table-column>
            <el-table-column prop="month" label="月份" min-width="100" align="center"> </el-table-column>
            <el-table-column prop="monthTime2" label="时间" min-width="160" align="center"> </el-table-column>
            <el-table-column label="状态" min-width="100" align="center">
              <template #default="{row}">
                <el-tag v-if="row.state">已生成</el-tag>
                <el-tag v-else type="danger">未生成</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="100">
              <template #default="{row}">
                <el-button v-if="!row.state" type="success" :loading="row.disabled" size="mini" plain
                  @click="generate(row)">生成</el-button>
                <span v-else style="display:flex;">
                  <!-- <el-button type="primary" size="mini" plain @click="goPreview(row)">打开</el-button> -->
                  <!-- <input type="file" @change="goPreview" value="11"> -->
                  <!-- <el-button @click="upload_" style="margin-right: 2vw">替换文件</el-button>
                  <input v-show="false" ref="fileRef" type="file" @change="fileChange($event)" /> -->
                  <el-button type="primary" size="mini" plain @click="exportFn(row)">导出</el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div ref="file"></div>

    <!-- 新增修改 -->
    <el-dialog width="800px" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div style="display: flex;" class="dialog">
        <el-form :model="temp" ref="temp" :rules="rules" label-width="100px" style="padding-top: 10px; display: flex;
        flex-wrap: wrap;" :inline="true">

          <el-form-item label="表底数:" prop="meterBase">
            <el-input v-model="temp.meterBase" type="number"></el-input>
          </el-form-item>
          <el-form-item label="抄表日期:" prop="deductionFeeDay">
            <el-select v-model="temp.deductionFeeDay" placeholder="请选择">
              <el-option v-for="item in 31" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>


        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import waterTree from '@/components/module/tree/waterTree.vue'
  import request from "@/api/http.js";
  var axios=require('axios')
  let docx=require("docx-preview");
  import {findICCards,saveIcCard,deleteIcCard,icCardSaveExcel,findMeterType} from "../../api/zhongshanMeter";
  export default {
    components: {
      waterTree
    },
    data () {

      return {
        dataTime: new Date(),//选择年
        defaultUnitId: '',
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        input: '',//密码
        centerDialogVisible: false,//输入密码弹窗
        areaName: '',//区域名称
        value: '',
        areaId: 'e9c9214fc3a64f2ab32307250df2a792',//区域id
        heights: document.getElementById('app').clientHeight-220,//屏幕高度 - 导航栏高度
        seraname: "",
        tableData: [],
        loading: false,
        //弹窗
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增水表档案",
          edit: "编辑水表档案"
        },
        //新增修改对象
        temp: {
          "meterRunType": 1,
          'meterReadingType': "water",
        },
        outTime: 0,//刷新倒计时
        TimeInt: null,//定时器
        //星号必填
        rules: {
          meterBase: [
            {required: true,message: '请输入表底数',trigger: 'blur'}
          ],
          deductionFeeDay: [
            {required: true,message: '请输入抄表日期',trigger: 'blur'}
          ],
          meterType: [
            {required: true,message: '请输入表类型',trigger: 'blur'}
          ],
        },
        roleOptions: [],
        typeList: [],
        paramsed: {},//控制水表参数
      };
    },
    watch: {
      filterText (val) {
        this.$refs.tree.filter(val);
      },
      dataList (nv,ov) {
        if(!isempty(this.dataList)) {
          this.defaultUnitId=this.dataList[0].id;
        }
      },
    },
    computed: {
      deviceDataList () {
        // 尚未被配置为抄表的设备筛选
        var tree=this.$store.deviceStore.getters.getControlDeviceTree;
        return tree
      },
      dataList () {
        var data=this.$store.unitStore.getters.getUnitTree;
        return isempty(data)? []:[deviceList(data)]
      },

    },

    mounted () {
      console.log("使用插件的renderAsync方法来渲染",docx); //
      if(!isempty(this.$store.unitStore.getters.getNowUnit)) {
        this.defaultUnitId=this.$store.unitStore.getters.getNowUnit.id;
        this.getList();
      }
    },


    methods: {
      upload_ () {
        //弹出选择本地文件
        this.$refs.fileRef.dispatchEvent(new MouseEvent('click'))
      },
      fileChange (e) {
        console.log(e)
        //获取流文件
        console.log(e.target.files,11)

        this.readFile(e.target.files[0])
        //获取文件名
        console.log(e.target.files[0].name)
      },
      readFile (file) {
        const reader=new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onerror=(e) => {
          this.$message.error('文件读取出错')
        }
        reader.onload=(e) => {
          this.$message.info('文件读取成功')
          const data=e.target.result
          // <!--把文件转换成文件流-->
          console.log(data);
          docx.renderAsync(data,this.$refs.file); // 渲染到页面
          var d=String.fromCharCode.apply(null,new Uint16Array(data))
          console.log(d);
        }
      },
      // 预览
      goPreview (v) {
        console.log(v,11);
        return
        axios({
          method: "get",
          responseType: "blob", // 因为是流文件，所以要指定blob类型
          url: "http://ashuai.work:10000/getDoc", // 自己的服务器，提供的一个word下载文件接口
        }).then(({data}) => {
          console.log(data); // 后端返回的是流文件
          docx.renderAsync(data,this.$refs.file); // 渲染到页面
        });
      },
      // 倒计时刷新
      setOutTime (v) {
        clearInterval(this.TimeInt)
        this.TimeInt=setInterval(() => {
          this.outTime--;
          console.log(this.outTime);
          if(!this.outTime) {
            clearInterval(this.TimeInt)
            this.getList();
          }
        },1000);
      },
      //生成
      generate (row) {
        var params={
          time: row.monthTime,
          unitId: this.defaultUnitId,
        }
        row.disabled=true;//禁止点击 
        // time   str
        request({url: "/ops/export",method: "get",params}).then(res => { //负荷设备数 
          var d=res.data.replace(/%2F/g,'/')

          if(res.success) {
            if(res.data=='后台报表生成中，请稍后重试！') {
              this.$message.error('后台报表生成中，需要等60秒');
              this.outTime=60;
              this.setOutTime();
              return
            }
            saveAs(DWSystemSetting.downloadUrl+d,v.fileName)
            this.$message({showClose: true,message: '导出成功',type: 'success'});
          } else {
            if(res.data) {
              this.$message.error(res.data);
            } else {
              this.$message.error('操作失败');
            }
          }
        })
      },
      // 点击树形
      nodeClick (value,nodeData) {
        this.defaultUnitId=value.id;
        this.getList();
        console.log(value);

      },
      filterNode (value,data) {
        if(!value) return true;
        return data.label.indexOf(value)!==-1;
      },


      // 导出
      exportFn (v) {
        var params={
          time: v.monthTime,
          unitId: this.defaultUnitId,
        }
        // time   str
        request({url: "/ops/export",method: "get",params}).then(res => { //负荷设备数 
          var d=res.data.replace(/%2F/g,'/')

          if(res.success) {
            if(res.data=='后台报表生成中，请稍后重试！') {
              this.$message.error(res.data);
              return
            }
            saveAs(DWSystemSetting.downloadUrl+d,v.fileName)
            this.$message({showClose: true,message: '导出成功',type: 'success'});
          } else {
            if(res.data) {
              this.$message.error(res.data);
            } else {
              this.$message.error('操作失败');
            }
          }
        })
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            var data=this.temp;
            data.areaId=this.areaId;
            request({url: "/water/saveWaterMeter.do",method: "post",data}).then(res => { //负荷设备数  
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;//关闭弹窗
                this.$message({showClose: true,message: '编辑成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('编辑失败');
                }
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        console.log(v,'v');
        this.temp=JSON.parse(JSON.stringify(v))
        this.value=[this.temp.deviceNo];//设备号  
        this.temp.deviceNos=[this.temp.deviceNo];//设备号 
        // this.temp.deviceNos=[20]
        this.dialogVisible=true;

        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },
      //获取数据
      getList () {
        var params={
          'time': new Date(this.dataTime).getTime(),
          'unitId': this.defaultUnitId,
        }
        this.loading=true
        request({url: "/ops/getExport",method: "get",params}).then(res => { //负荷设备数 
          console.log(res);
          this.loading=false;
          res.data.map(v => {
            v.monthTime2=new Date(v.monthTime).format('yyyy-MM-dd');
            v.disabled=false;
          })
          if(res.code==200) {
            this.tableData=res.data;
          } else {
            this.$message.error(res.message);
          }
        })
      },

    },
    filters: {
      //费率类型 ELECTRIC(电)  WATER(水) GAS(气)
      energyType (val) {
        if(val=='ELECTRIC') {
          return "电"
        } else if(val=='WATER') {
          return "水"
        } else {
          return "气"
        }
      },
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .FilesManage {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;

    .left-tree {
      width: 3rem;
      height: 100%;
      flex-shrink: 0;
      margin-left: 10px;
      border-right: 1px solid #E6E6E6;
      overflow: hidden;
    }

    .el_Tree_Body {
      border: 0px;
    }

    .right-table {
      width: 100%;
      flex: 1;
      overflow: scroll;

      .Files-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0px 20px;
        height: 70px;

        .ic-left {
          display: flex;
          align-items: center;

          span {
            white-space: nowrap;
          }
        }

        span {
          color: #1a1a1a;
        }

        /deep/.el-upload--picture-card {
          width: 100%;
          height: 32px;
          line-height: 32px;
          border: 0px;
        }

        .btns {
          display: flex;
        }

      }

      .Files-table {
        margin: 0px 20px;

        /deep/.el-table th {
          background-color: #F3F8FF;
          color: #999999;
          border-right: 1px solid #E6E6E6;
          padding: 10px 0px;
          font-weight: bold;
        }

        /deep/.el-table td {
          padding: 1px 0px;
          height: 44px;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .blue {
          background-color: #52A1FF;

        }

        .ash {
          background-color: #999999;

        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
        margin-right: 15px;
      }

    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

    .dialog {
      /deep/.el-input__inner {
        width: 217px;
      }
    }

    /deep/.el-input__inner {
      height: 34px;
      line-height: 34px;
    }

    /deep/.el-input__icon {
      line-height: 34px;
    }

  }

  /deep/.el-tree-node__content {
    width: 3rem;
  }
</style>